import album from './requests/album/endpoints';
import analytic from './requests/analytic/endpoints';
import artist from './requests/artist/endpoints';
import playlist from './requests/playlist/endpoints';
import track from './requests/track/endpoints';
import claim from './requests/claim/endpoints';
import search from './requests/search/endpoints';
import auth from './requests/auth/endpoints';
import users from './requests/users/endpoints';
import profiles from './requests/profiles/endpoints';
import utils from './requests/utils/endpoints';
import pitches from './requests/pitches/endpoints';
import campaigns from './requests/campaigns/endpoints';
import copyrightClaims from './requests/copyright-claims/endpoints';

export default {
	album,
	analytic,
	artist,
	campaigns,
	copyrightClaims,
	playlist,
	track,
	claim,
	search,
	auth,
	users,
	profiles,
	utils,
	pitches,
};
